import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DateTimeSheetOptions } from './datetime-sheet.model';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';
import { format, formatISO, parse, parseISO } from 'date-fns';

@Component({
  selector: 'app-datetime-sheet',
  templateUrl: './datetime-sheet.component.html',
  styleUrls: ['./datetime-sheet.component.scss']
})
export class DateTimeSheetComponent implements OnInit {

  @Input() config: DateTimeSheetOptions;
  translations: any;
  destroyed$ = new Subject<boolean>();

  public day: string;
  public currentStart: string;
  public currentEnd: string;
  public isClosed: boolean;

  public maxDate = (Number(new Date().getFullYear()) + 1) + '-12-31';
  public customDate: any;
  public currentTime: any;

  public defaultDate: any;
  public defaultTime: any;

  public localeString: string;
  public customPres: string = 'date-time';
  public paramPres: string;
  public currentDate: string;

  public modalType = 1;
  minInsterval: number[];
  typeTimeActive = 0;

  // theme: ThemeEnum = ThemeEnum.omni;
  constructor(
    private modalCtrl: ModalController,
    private translate: TranslateService,
    public storageService: LocalStorageNativeService
  ) {
    this.translate
      .get(['QR', 'CLIPBOARD', 'PANEL_VIEW', 'EVENTS_MODULE', 'ACTIONS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));
  }

  ngOnInit() {
    if (this.config.data.toString() === 'Cerrado' || this.config.data.toString() === 'Closed') {
      this.isClosed = true;
      this.currentStart = null;
      this.currentEnd = null;
      return;
    }
    else {
      this.setTimeFromSchedule(this.config.data.toString());
    }

    this.getLanguageApp();
    if (this.paramPres) {
      this.customPres = this.paramPres;
    }
  }

  toggleChanged() {
    this.updateTimeBasedOnToggle();
  }

  updateTimeBasedOnToggle() {
    if (!this.isClosed) {
      this.currentStart = null;
      this.currentEnd = null;
    } else {
      const now = new Date();
      const _timeStart = format(now, 'hh:mm aaaa').replace('AM', 'a.m.').replace('PM', 'p.m.');
      const startTime = parse(_timeStart, 'hh:mm a', now); // '10:00 a.m.'
      this.currentStart = format(startTime, "yyyy-MM-dd'T'HH:mm:ss");
      this.currentEnd = format(startTime, "yyyy-MM-dd'T'HH:mm:ss");
    }
  }

  setTimeFromSchedule(schedule: string) {
    const [start, end] = schedule.split(' - ');

    // Convertimos cada valor a una fecha usando la fecha actual
    const currentDate = new Date();
    const startTime = parse(start, 'hh:mm a', currentDate); // '10:00 a.m.'
    const endTime = parse(end, 'hh:mm a', currentDate); // '05:00 p.m.'

    // Convertimos a cadenas ISO para ion-datetime
    this.currentStart = format(startTime, "yyyy-MM-dd'T'HH:mm:ss");
    this.currentEnd = format(endTime, "yyyy-MM-dd'T'HH:mm:ss");
  }

  onTimeChangeStart(event: any) {
    console.log('Start Time Changed:', event.detail.value);
  }

  onTimeChangeEnd(event: any) {
    console.log('End Time Changed:', event.detail.value);
  }

  closeActionSheet() {
    this.modalCtrl.dismiss();
  }

  async getLanguageApp() {
    const language = await this.storageService.getItem('selectedLanguage');
    if (language || language !== null) {
      this.localeString = (language === 'es') ? 'es-MX' : 'en-US';
    }
    else {
      this.localeString = 'en-US';
    }
  }

  getFormattedSchedule(): string {
    if (!this.currentStart || !this.currentEnd) return '';

    const start = parseISO(this.currentStart);
    const end = parseISO(this.currentEnd);

    const formattedStart = format(start, 'hh:mm aaaa');
    const formattedEnd = format(end, 'hh:mm aaaa');

    return `${formattedStart} - ${formattedEnd}`;
  }

  selectDate() {
    if (!this.isClosed) {
      this.modalCtrl.dismiss({
        value: ''
      });
    }
    else {
      const formattedSchedule = this.getFormattedSchedule();
      this.modalCtrl.dismiss({
        value: formattedSchedule
      });
    }
  }

  setTypeTimeActive(_type: number) {
    console.log('_type: ', _type)
    console.log('this.typeTimeActive: ', this.typeTimeActive)
    if (this.typeTimeActive === 1 && _type === 1) {
      this.typeTimeActive = 0;
    }
    else if (this.typeTimeActive === 0 && _type === 1) {
      this.typeTimeActive = 1;
    }
    else if (this.typeTimeActive === 2 && _type === 2) {
      this.typeTimeActive = 0;
    }
    else if (this.typeTimeActive === 0 && _type === 2) {
      this.typeTimeActive = 2;
    }
    else if (this.typeTimeActive === 1 && _type === 2) {
      this.typeTimeActive = 2;
    }
    else if (this.typeTimeActive === 2 && _type === 1) {
      this.typeTimeActive = 1;
    }
  }

}
